import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const ExemptArizona = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Kansas Non-Profit State Filing Requirements & Deadlines"
          description="Learn Kansas’s non-profit filing requirements, deadlines, and compliance rules. Ensure your organization stays in good standing with the state. "
          keywords=" "
          canonical="nonprofit-taxes/kansas-state-filing-requirements/"
          // jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Final Day to E-File Form W-2!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>Last Day</b> to
              Submit Your <b>Form W-2</b> Electronically!
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ks-landing-img.webp" />
                <source srcSet="/assets/images/1099-ks-landing-img.png" />
                <img
                  src="/assets/images/1099-ks-landing-img.png"
                  alt="Kansas State Filing Requirements "
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                <span className="highlight-container">
                  <span className="highlight">Kansas State </span>
                </span>{' '}
                Filing
                <Hidden mdDown>
                  <br />
                </Hidden>{' '}
                Requirements
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Non-profits in Kansas must comply with specific state filing
                requirements to maintain their legal status and tax exemptions.
              </Typography>

              {/* <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=kansas`}
                  >
                    Get Started
                  </Button>
                 
                </Box>
              </Stack> */}
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/1099-ks-landing-img-sm.webp" />
                <source srcSet="/assets/images/1099-ks-landing-img-sm.png" />
                <img
                  src="/assets/images/1099-ks-landing-img-sm.png"
                  alt="Kansas State Filing Requirements"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ pt: 4, pb: 4 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              pt: 5,
              textAlign: 'center',
            }}
          >
            Required Non-profit Forms
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
              fontWeight: 400,
              mb: 2,
              textAlign: 'center',
            }}
          >
            Non-profits in Kansas are required to complete several forms as part
            of their compliance obligations.
          </Typography>
          <Grid container spacing={2}>
            <Grid
              size={12}
              sx={{
                px: { md: 3, sm: 0, xs: 0 },
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{ mb: 5 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Department of Revenue Forms
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Forms (Required for State Compliance)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.ks.gov/forms/business_services/AI.pdf"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Articles of Incorporation
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.ag.ks.gov/home/showpublisheddocument/2630/638459083432930000"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Charitable Organization Registration Statement
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.ks.gov/forms/business_services/CN.pdf"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Certificate of Amendment
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.sos.ks.gov/forms/business_services/DS.pdf"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Certificate of Dissolution
                              </Link>{' '}
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://sos.ks.gov/businesses/businesses.html"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Annual Report for Non-profit Corporations -
                                Filing Portal
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>

                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.ksrevenue.gov/pdf/cr16.pdf"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Form CR-16 - Kansas Business Tax Application
                                Form
                              </Link>
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="https://www.ksrevenue.gov/pdf/st28.pdf"
                                sx={{ color: '#0202ff' }}
                                target="_blank"
                              >
                                Form ST-28- Sales Tax Exemption Certificate
                              </Link>{' '}
                            </li>
                          </ul>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                          }}
                        >
                          <ul>
                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1023 (Application for Recognition of
                                Exemption Under Section 501(c)(3) of the
                                Internal Revenue Code):
                              </span>{' '}
                              For most charitable organizations
                            </li>

                            <li style={{ marginBottom: 8 }}>
                              <span style={{ fontWeight: 600 }}>
                                {' '}
                                Form 1024 (Application for Recognition of
                                Exemption Under Section 501(a) or Section 521 of
                                the Internal Revenue Code):
                              </span>{' '}
                              For other types of nonprofits.
                            </li>
                            <li style={{ marginBottom: 8 }}>
                              <Link
                                href="/tax-exempt/e-file-irs-form-990/"
                                sx={{ color: '#0202ff' }}
                              >
                                <span style={{ fontWeight: 600 }}>
                                  {' '}
                                  Form 990 (Return of Organization Exempt From
                                  Income Tax):
                                </span>
                              </Link>{' '}
                              Annual information return for tax-exempt
                              organizations.
                            </li>
                          </ul>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        component="section"
        maxWidth="lg"
        sx={{ pt: 6, pb: 6, textAlign: 'center' }}
      >
        <Grid
          container
          spacing={2}
          direction={{ md: 'row', xs: 'column-reverse' }}
          sx={{ pt: 5, pb: 2 }}
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <Box
              sx={{
                px: { md: 0, sm: 0, xs: 2 },
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: { md: 'left', xs: 'center' },
              }}
            >
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { md: 3, sm: 1, xs: 0 },
                  pt: { md: 0, sm: 3 },
                  textAlign: { md: 'left', sm: 'center' },
                }}
              >
                State Filing Requirements for Non-Profits
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                To operate legally as a non-profit in Kansas, your organization
                generally needs to fulfil the following key requirements:
              </Typography>
              <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    File Articles of Incorporation{' '}
                  </span>{' '}
                  <br />
                  Submit to the Kansas Secretary of State to legally form your
                  non-profit.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Obtain EIN</span> <br />
                  Required by the IRS for banking, tax exemption, and
                  operations.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> Adopt Bylaws </span> <br />
                  Internal governance rules kept at the organization’s office.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Apply for Tax Exemptions
                  </span>{' '}
                  <br />
                  File with the IRS for 501(c)(3) status; apply with the Kansas
                  Department of Revenue for sales/use tax exemption.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Register with Kansas DOR
                  </span>{' '}
                  <br />
                  File Kansas Business Tax Application (Form CR-16)
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Register as a Charity
                  </span>{' '}
                  <br />
                  Required if soliciting donations from the public.
                </li>
                <li>
                  <span style={{ fontWeight: 600 }}> File Annual Reports </span>{' '}
                  <br />
                  Due to the Secretary of State by the 15th day of the sixth
                  month after your tax year ends.
                </li>
              </Box>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6 }}
            sx={{
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Box>
              <picture>
                <source srcSet="/assets/images/who-file-ks-img.webp" />
                <source srcSet="/assets/images/who-file-ks-img.png" />
                <img
                  src="/assets/images/who-file-ks-img.png"
                  alt="State Filing Requirements for Non-Profits"
                  className="img-responsive img-shadow"
                  loading="lazy"
                  width={500}
                  height={500}
                />
              </picture>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{
              my: { xs: 2, sm: 6, md: 8 },
              textAlign: { md: 'left', sm: 'center', xs: 'center' },
            }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              sx={{
                textAlign: 'left',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  borderRadius: 5,
                  backgroundColor: '#fff',
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                      fontWeight: 600,
                      mb: 3,
                      textAlign: 'center',
                      lineHeight: 1.5,
                    }}
                  >
                    Tax Exemption Requirements
                  </Typography>
                  <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    To maintain tax-exempt status in{' '}
                    <span style={{ fontWeight: 600 }}> Kansas</span>,
                    organizations must:
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      '& li svg': { float: 'left', fontSize: 27 },
                    }}
                  >
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Must have 501(c)(3) status from the IRS.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Must submit IRS letter, articles of incorporation, and
                      bylaws.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply for a{' '}
                      <span style={{ fontWeight: 600 }}>
                        {' '}
                        Kansas Sales Tax Exemption Certificate
                      </span>{' '}
                      from the Kansas Department of Revenue.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Apply with the county appraiser in each county where
                      property is located.
                    </li>
                    <li style={{ marginBottom: 12 }}>
                      <FastForwardOutlinedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />
                      Exemption applies to purchases made directly by the
                      nonprofit.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        // className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} className="responsive">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Filing Deadlines for Non-Profit Forms
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Adhering to filing deadlines is essential to avoid penalties and
                maintain compliance.
              </Typography>
            </Grid>
            <Grid size={12} className="responsive">
              {' '}
              <Typography variant="body1" sx={{ mb: 1 }}>
                Below are the key deadlines for non-profit filings in Kansas:
              </Typography>
              <Box component="div" sx={{ mb: 2 }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Secretary of State Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Articles of Incorporation
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by the 15th day of the fourth month after the
                          close of the fiscal year, every other year
                          (biennially), not annually
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Annual Reports
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due by June 15th of their respective odd or even year.
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Charitable Organization Registration Statement for
                          Solicitations
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Within 30 days of starting charitable solicitation
                          activities
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Kansas Department of Revenue Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            width: 400,
                          }}
                        >
                          Kansas Business Tax Application (Form CR-16)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          This application should be filed relatively soon after
                          the formation of your non-profit to handle state tax
                          obligations.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2, mb: 4 }}
                >
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          colSpan={2}
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,

                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Federal Deadlines
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 990 Series
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Due on the 15th day of the 5th month after the
                          organization&apos;s accounting period ends
                          <br />
                          <b>Example:</b> For calendar year organizations, Form
                          990 is due by May 15
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',

                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                            fontWeight: 600,
                            width: 400,
                          }}
                        >
                          Form 1023/1023-EZ
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Must be filed within 27 months of incorporation to
                          receive retroactive exemption to the date of
                          incorporation
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            {/* <Grid size={12}>
              <Box component="div" sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    mb: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=kansas`}
                >
                  E-file Now with TaxZerone
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: 6 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mt: 4,
              mb: 3,
              textAlign: 'center',
            }}
          >
            Registration & Annual Filing (Non-Profits)
          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center' }}>
            To operate legally as a non-profit in Kansas, the registration
            process involves several steps:
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{ mt: 4, mb: 4, px: { md: 11, sm: 2, xs: 0 } }}
          >
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Initial Registration
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Choose a Name
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Ensure your organization&apos;s name is distinguishable from
                    other registered businesses and includes a word or
                    abbreviation indicating its non-profit status (e.g.,
                    &quot;Association,&quot; &quot;Corporation,&quot;
                    &quot;Inc.&quot;).
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Appoint a Registered Agent
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    You must designate a registered agent located in Kansas to
                    receive legal and official documents on behalf of your
                    non-profit.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. File Articles of Incorporation
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Complete the Articles of Incorporation form with the
                    required information, and file this form with the Kansas
                    Secretary of State, along with the applicable filing fee
                    (currently $20 for online or mail filing).
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Obtain an EIN
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    Apply for an EIN from the IRS. This can be done online
                    through the IRS website.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    5. Apply for Tax Exemptions
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    Apply for federal tax-exempt status under Section 501(c)(3)
                    of the Internal Revenue Code (if applicable) by filing Form
                    1023
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} className="responsive">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 2,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  // display: 'flex',
                  // gap: 2,
                  // alignItems: 'start',
                  backgroundColor: '#fff',
                }}
              >
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                    }}
                  >
                    Annual Filing Requirements
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    1. Biennial Information Report
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    File this report with the Kansas Secretary of State by June
                    15th of the appropriate year (odd or even, based on the
                    formation year). This report keeps the state updated on your
                    organization&apos;s key information.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    2. Annual Registration with the Attorney General (for
                    Charitable Organizations)
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    If your non-profit is registered to solicit donations, you
                    will likely need to renew your registration annually with
                    the Kansas Attorney General.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    3. Maintain Compliance with IRS
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 2 }}>
                    File the annual Form 990 series (990, 990-EZ, 990-N, or
                    990-PF) with the IRS. Failure to do so for three consecutive
                    years can result in automatic revocation of federal
                    tax-exempt status.
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                    4. Keep Corporate Records
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 0 }}>
                    Maintain proper corporate records, meeting minutes, and
                    financial records as required by Kansas nonprofit
                    corporation law.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Simplified IRS Reporting for Nonprofits
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          TaxZerone provides compliant and easy-to-use nonprofit filing
          solutions.
        </Typography>
        {/* <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=kansas`}
          >
            E-File Now!
          </Button>
        </Box> */}
      </Box>
      <Container component="section" maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            className="responsive"
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Are churches required to register as charitable
                  organizations in Kansas?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Churches and other religious organizations are generally
                    exempt from the charitable solicitation registration
                    requirement in Kansas. However, they must still file annual
                    reports as non-profit corporations with the Secretary of
                    State.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What is the deadline for filing the Biennial Information
                  Report for Kansas non-profits?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      For Kansas nonprofits, the deadline to file the Biennial
                      Information Report is June 15th of the relevant year,
                      depending on whether your organization was formed in an
                      even or odd year.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What happens if a non-profit in Kansas misses the annual
                  report filing deadline?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      If a non-profit corporation fails to file its annual
                      report by the deadline, it will be assessed a late fee. If
                      the report remains unfiled for a significant period, the
                      Secretary of State may administratively dissolve the
                      corporation.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Are there any special requirements for out-of-state
                  non-profits operating in Kansas?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Out-of-state nonprofits operating in Kansas must register
                      as a &quot;foreign nonprofit&quot; with the Kansas State
                      (.gov), obtain a certificate of good standing from their
                      home state, and comply with Kansas&apos;s Charitable
                      Organizations and Solicitations Act if soliciting
                      donations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Do I need a federal EIN to operate a non-profit in Kansas?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      While the state doesn&apos;t explicitly require it for
                      incorporation, you will likely need an EIN from the IRS to
                      open a bank account, apply for federal tax exemption, and
                      other essential operations.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                <Accordion
                  defaultExpanded
                  sx={{
                    '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                      {
                        background: 'none !important',
                      },
                    '&.MuiAccordion-root': { background: 'none !important' },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls=""
                    id=""
                    sx={{
                      px: 0,
                      m: 0,
                      justifyContent: 'flex-start',
                      '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                        { m: '0 !important', flexGrow: 0 },
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        color: '#014361',
                        fontSize: 16,
                      }}
                    >
                      Sources and References
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      This resource guide is compiled from authoritative
                      sources, including:
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <Link
                          href="https://www.kssos.org/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Kansas Secretary of State
                        </Link>
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="https://www.ksrevenue.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Kansas Department of Revenue
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.ag.ks.gov/divisions/civil/licensing-inspections/charitable-organization-registration"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Kansas Attorney General – Charitable Organizations
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://sos.ks.gov/businesses/information-reports.html"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Kansas Secretary of State - Information Reports
                        </Link>
                      </li>{' '}
                      <li>
                        {' '}
                        <Link
                          href="https://www.irs.gov/"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Internal Revenue Service (IRS)
                        </Link>
                      </li>{' '}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Alert>
            </Box>{' '}
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default ExemptArizona;
